// extracted by css-extract-rspack-plugin
export default {"wrapper":"_ba9640e0","closed":"_ab5a7a41","cta":"_abaa2fe5"};